export const QuestionTimeComponent = {
  bindings: {
    question: '<',
    hasError: '<',
    questionOptions: '<',
    answers: '=',
    actionClickedFn: '=?',
    previousAnswers: '<',
    isDisabled: '<?',
  },
  require: {
    sfQuestionForm: '^sfQuestionForm',
  },
  templateUrl:
    'missions/components/Form-questions/question-time/question-time.html',
  controller: function QuestionTimeController(FORM_QUESTION_ACTIONS) {
    'ngInject';
    const isDefined = (value) => typeof value !== 'undefined' && value !== null;
    const getValues = (value) => {
      var values = [{ field_id: this.firstField._id, value: value }];

      return values;
    };

    this.$onInit = () => {
      const curValue = this.answers.length
        ? this.answers[0].values[0].value
        : null;

      this.firstField = this.question.fields[0];
      this.value = curValue;
      this.actionClickedFn = this.actionClicked;
    };

    this.onValueChange = (value) => {
      const values = isDefined(value) ? getValues(value) : null;

      this.answers = this.updateAnswers(values, this.answers);
    };
    this.updateAnswers = (values, answers) => {
      var answer = this.answers[0] || null;

      return values
        ? this.sfQuestionForm.saveAnswer(values, answers)
        : answer
        ? this.sfQuestionForm.removeAnswer(answer._id, answers)
        : answers;
    };

    this.actionClicked = (action) => {
      switch (action) {
        case FORM_QUESTION_ACTIONS.RESET_PREFILL:
          return this.resetToPrefillValue();
        default:
          return false;
      }
    };

    this.resetToPrefillValue = () => {
      if (this.previousAnswers && this.previousAnswers.length) {
        this.value = this.previousAnswers[0].values[0].value;
        this.onValueChange(this.value);
      }
    };
  },
};
